import React, { memo, Fragment } from "react";

//router
import Link from "next/link";

const Logo = memo(() => {
  return (
    <Fragment>
      <div className="logo-default">
        <Link className="navbar-brand text-primary d-flex align-items-center" href="/">
          <img
            className="img-fluid logo"
            src="/assets/images/g-icon.svg"
            loading="lazy"
            alt="G"
            style={{ filter: 'brightness(0) invert(1)' }}
          />
          <span className="ms-2 logo-text">G-School</span>
        </Link>
      </div>
    </Fragment>
  );
});

Logo.displayName = "Logo";
export default Logo;
